import { useMutation, useQueryClient } from "react-query";

import { Video } from "../../types";
import VideoService from "../../services/Video";

import { QUERY_KEY } from "./useListVideos";
import { makeQueryKey } from "./useFetchVideo";

function useUpdateVideo(onSuccess?: (video: Video) => void) {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, ...updates }: { id: Video["id"] } & Partial<Video>) =>
      VideoService.updateVideo(id, updates),
    {
      onSuccess: (video) => {
        queryClient.invalidateQueries(QUERY_KEY);
        queryClient.setQueryData(makeQueryKey(video.id), video);

        onSuccess?.(video);
      },
    }
  );
}

export default useUpdateVideo;
